export const TAILWIND_CUSTOM_CLASSES_TEXT = [
  "heading-lg",
  "heading-md",
  "heading-sm-bold",
  "heading-sm-semibold",
  "heading-sm",
  "heading-xs-bold",
  "heading-xs-semibold",
  "heading-xs-medium",
  "heading-2xs",
  "body-lg",
  "body-lg-semibold",
  "body-base",
  "body-base-semibold",
  "body-sm",
  "button-xl",
  "button-lg",
  "button-base",
  "button-sm",
  "button-xs",
  "2xl",
  "xl",
  "xl-medium",
  "lg",
  "lg-medium",
  "md",
  "md-mono",
  "md-medium",
  "md-bold",
  "sm",
  "sm-medium",
  "sm-semibold",
  "sm-mono",
  "xs",
] as const
